import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12.5 21h-6.5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v7","key":"svg-0"}],["path",{"d":"M9 18h3","key":"svg-1"}],["path",{"d":"M16 19a3 3 0 1 0 6 0a3 3 0 1 0 -6 0","key":"svg-2"}],["path",{"d":"M17 21l4 -4","key":"svg-3"}]]

const IconDeviceIpadCancel = createReactComponent('outline', 'device-ipad-cancel', 'DeviceIpadCancel', __iconNode);

export default IconDeviceIpadCancel;